<template>
    <div class="login-box">
        <div class="login-container">
            <div class="login-inner">
                <div class="login-right">
                    <div class="form-logo">
                        <img src="/static/logo.svg">
                    </div>
                    <div class="form-box">
                        <h3 class="form-title">{{$t('Forgot password?')}}</h3>
                        <span class="line"></span>
                        <el-form :label-position="labelPosition" :model="passwordForm" :rules="rules" ref="passwordForm" @submit.native.prevent novalidate>
                            <el-form-item prop="email">
                                <el-input type="email" name="email" placeholder="E-Mail Adresse eingeben" v-model="passwordForm.email"
                                    @keyup.enter.native="validateBeforeSubmit('passwordForm')"></el-input>
                            </el-form-item>
                            <el-form-item class="no-margin">
                                <el-button class="log-btn sub-btn" type="primary" @click="validateBeforeSubmit('passwordForm')">Submit</el-button>
                                <router-link class="log-back-btn margin-top5" to="/login"><i class="el-icon-d-arrow-left"></i>{{$t('Back to login')}}</router-link>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    @import "@/assets/sass/_login.scss";

</style>
<script>
    export default {
        data() {
            return {
                passwordForm: {
                    email: ""
                },
                labelPosition: "top",
                rules: {
                    email: [{
                            required: true,
                            message: this.$t("This field is required"),
                            trigger: "change"
                        },
                        {
                            type: "email",
                            message: this.$t("Please input valid email address"),
                            trigger: ["blur", "change"]
                        }
                    ]
                }
            };
        },
        mounted() {},
        methods: {
            validateBeforeSubmit(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "auth/password",
                                method: "post",
                                data: this.passwordForm
                            })
                            .then(response => {
                                this.$notify({
                                    title: "Success",
                                    message: response.data.message,
                                    type: "success"
                                });
                                this.$router.push("/login");
                            })
                            .catch(error => {
                                this.$notify({
                                    title: "Error",
                                    message: error.response.data.message,
                                    type: "error"
                                });
                            });
                    }
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Auth/ForgotPassword.vue